module.exports = __webpack_public_path__ + "img/call.76b73a31.svg";